module.exports = __webpack_public_path__ + "img/czar_lawy.8320d7b8.jpg";